import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import lotService from "../../services/lot-service";

import { Divider, message, Spin, Upload } from "antd";
import Dragger from "antd/es/upload/Dragger";
import { UploadProps } from "antd";
import moment from "moment";
import axios from "axios";
import fileService from "../../services/file-service";
import { URL_BASE } from "../../config/url-server";
import { ToastContainer, toast } from 'react-toastify';

const UpdateCoordinatesExcel = () => {
  const { Dragger } = Upload;
  const [file, setFile] = useState("NOK");
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD")
  );

  let navigate = useNavigate();
  const [listLots, setListLots] = useState([]);
  const [title, setTitle] = useState(false);
  const [showSave, setShowSave] = useState(true);

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();


  const toUpperFieldName = (e) => {
    let value = e.target.value;
    setValue("name", value.toUpperCase());
  };

  ////FUNCIONES QUE USAN EL SERVICIO LOTSERVICE
  ////FUNCIONES QUE USAN EL SERVICIO LOTSERVICE

  const customSubmit = async (data) => {
    setLoading(true)
    const result = await fileService.updateLocations(data);
    setLoading(false)
    if (result) {
      const success = result.data.success;
      if (success) {
        const message = result.data.message;
        toast(<div>
          {
          message.split('\n').map((line, index) => (
            <span key={index}>
              {line}
              <br />
            </span>
          ))}
        </div>, { autoClose: 2500 });
        setFile("");
        setFileList([]);
        setValue("document", "");
      } else {
        console.log(result.data.errors)
      }
    }
  };

  const downloadFile = async (folder, filename) => {
    try {
      setLoading(true);
      const response = await axios({
        url: URL_BASE + "file/download",
        method: "GET",
        responseType: "blob",
        params: { folder, filename },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      setLoading(false);
      setFile("");
      setFileList([]);
      setValue("document", "");
    } catch (error) {
      console.error("Error al descargar el archivo:", error);
      setLoading(false);
    }
  };



  const verifyTitle = (fileName) => {
    let message = ""
    let lot_name = localStorage.getItem("lotName");
    fileName = fileName.toUpperCase()
    lot_name = lot_name.toUpperCase()
    let result = fileName.includes("lot_name");
    if (!fileName.includes(lot_name)) {
      return "Titulo del excel no contiene: " + lot_name;
    }
    if (!fileName.includes("GEO")) {
      return "Titulo del excel no contiene la palabra: GEO ";
    }
    return "OK"
  }




  const props = {
    name: "file",
    height: "100px",
    multiple: false,
    fileList: fileList,
    accept: ".xlsx",
    maxCount: 1,
    action: URL_BASE + "file/upload",

    onChange(info) {


      const username = localStorage.getItem("username");
      if (username != "superadmin") {
        toast.error('Usuario sin privilegios!', { autoClose: 1000 });
        return;
      }



      const res = verifyTitle(info.file.name)
      if (res != "OK") {
        toast.error(res, {
          autoClose: false,
          onClick: () => {
            toast.dismiss();
          }
        });
        return
      }



      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        const response = info.file.response;
        if (response && response.status === "success") {
          const { originalname, filename, path, size } = response.file;
          toast(`${originalname} subido exitosamente.`, { autoClose: 1000 });
          setFile(filename);
          setValue("document", filename);
        } else {
          toast.error("Error en la respuesta del servidor.");
        }
      } else if (status === "error") {
        toast.error(`${info.file.name} file upload failed.`);
      }

      setFileList(info.fileList);
    },
    onRemove: async (e) => {
      try {
        const response = await axios.delete(
          `https://core.palmicultor.com.co/api/file/delete/${file}`
        );
        if (response.data.status === "success") {
          setFile("");
          setFileList([]);
          setValue("document", "");
        } else {
          console.error("Error al eliminar el archivo:", response.data.message);
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
      }
    },
  };

  const getListByFarm = async () => {
    const farm_id = localStorage.getItem("farmId");
    const listado = await lotService.getListByFarm(farm_id);
    setListLots(listado);
  };

  const getLot = async (lotId) => {
    const lot = await lotService.getLot(lotId);
    if (lot) {
      setValue("farmId", lot.farmId);
      setValue("farmName", lot.farmName);
      setValue("lotId", lot._id);
      setValue("lotName", lot.name);
      setShowSave(false);
    }
  };




  useEffect(() => {
    const farm_id = localStorage.getItem("farmId");
    const lot_id = localStorage.getItem("lotId");
    getListByFarm(farm_id);
    getLot(lot_id);
    const farm_name = localStorage.getItem("farmName");
    const lot_name = localStorage.getItem("lotName");
    setTitle(`${farm_name} - ${lot_name}`);

  }, []);



  return (
    <div className="row px-3 pt-3 pb-3 bg-light ">
      <ToastContainer />
      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Actualizar coordenadas desde Excel - {title}</Divider>
      </div>

      <div className="col-12 ms-2">
        <Link to="/admin-lots" className="nav-link link-primary p-1">
          <i className="bi bi-arrow-left-short fa-lg"></i>
          <span className="fs-6 m-1">
            <strong>REGRESAR A LA FINCA</strong>
          </span>
        </Link>
      </div>

      <div className="col-12 col-sm-5 card p-4 ms-4">
        <form className="form-react" onSubmit={handleSubmit(customSubmit)}>
          <div className="row">
            <div className="card-title">
              <h4>Actualizar GPS plantas</h4>
            </div>

            <div className=" col-12 d-none">
              <label>Id lote</label>
              <input
                readOnly={true}
                type="text"
                className="form-control bg-light"
                {...register("lotId")}
              />
            </div>

            <div className=" col-12 d-none">
              <label>Id Finca</label>
              <input
                readOnly={true}
                type="text"
                className="form-control bg-light"
                {...register("farmId")}
              />
            </div>

            <div className=" col-12 col-sm-6">
              <label>Finca</label>
              <input
                readOnly={true}
                type="text"
                className="form-control bg-light"
                {...register("farmName")}
              />
            </div>

            <div className=" col-12 col-sm-6">
              <label>Lote</label>
              <input
                type="text"
                readOnly={true}
                onKeyUp={toUpperFieldName}
                className="form-control bg-light"
                {...register("lotName")}
              />
            </div>

            <div className=" col-12 d-none">
              <label>Document</label>
              <input
                type="text"
                readOnly={true}
                onKeyUp={toUpperFieldName}
                className="form-control bg-light"
                {...register("document", { required: true, minLength: 3 })}
              />
              {errors.name?.type === "required" && (
                <small className="text-danger">Campo requerido</small>
              )}
              {errors.name?.type === "minLength" && (
                <small className="text-danger">Minimo 15 caracteres</small>
              )}
            </div>


            <div className="col-12 mt-4" style={{ height: '130px' }}>
              <div className="row">
                <div className="col-12">
                  <Dragger {...props}>
                    <p className="ant-upload-drag-icon"></p>
                    <p className="ant-upload-text">
                      Click o arrastre para subir
                    </p>
                    <p className="ant-upload-hint">
                      Solo se aceptan archivos con extensión xlsx.
                    </p>
                  </Dragger>
                </div>
              </div>
            </div>


            <div className=" col-12 col-sm-6">
              <label>&nbsp; </label>
              <Spin spinning={loading} >
                <button className="btn btn-primary w-100" type="submit">
                  <i className="bi bi-save fa-lg m-2" /> Guardar
                </button>
              </Spin>
            </div>
          </div>
        </form>
      </div>


    </div>
  );
};

export default UpdateCoordinatesExcel;
